module.exports = {
  STAFF: 'STAFF',
  GUEST: 'CUSTOMER',

  TAKE_AWAY: 'TAKE_AWAY',
  EAT_HERE: 'EAT_IN',

  ALL_YOU_CAN_EAT: 'ALL_YOU_CAN_EAT',
  ALL_YOU_CAN_DRINK: 'ALL_YOU_CAN_DRINK',
  HAPPY_HOUR: 'HAPPY_HOUR',

  PLACED: 'PLACED',
  PREPARING: 'PREPARING',
  PARTIAL_DONE: 'PARTIAL_DONE',
  DONE: 'DONE',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',

  SENT_TO_KITCHEN: 'SENT_TO_KITCHEN',
  FOOD_READY: 'FOOD_READY',

  AVAILABLE: 'AVAILABLE',
  RESERVED: 'RESERVED',

  MALE: 'MALE',
  FEMALE: 'FEMALE',
  KIDS: 'KIDS',
  OTHERS: 'OTHERS',
};
